import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationData } from '@shared/modals/confirmation-modal/shared/confirmation-data';
import {
  ConfirmationModalStoreService
} from '@shared/modals/confirmation-modal/shared/confirmation-modal-store.service';
import { ModalContainerComponent } from '@shared/ui-components/modal-container/modal-container.component';

@Component({
  selector: 'evland-confirmation-modal',
  imports: [
    ModalContainerComponent,
  ],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationModalComponent {
  data: Signal<ConfirmationData>;
  cancelButtonClass: Signal<string>;
  cancelButtonLabel: Signal<string>;
  confirmButtonClass: Signal<string>;
  confirmButtonLabel: Signal<string>;

  private activeModal = inject(NgbActiveModal);
  private confirmationModal = inject(ConfirmationModalStoreService);

  constructor() {
    this.initData();
  }

  onClose(): void {
    this.activeModal.close();
  }

  onConfirm(): void {
    this.activeModal.close(true);
  }

  private initData(): void {
    this.data = this.confirmationModal.currentS;
    this.cancelButtonLabel = computed(() => {
      const data = this.data();

      return data?.cancelButtonLabel || $localize`Ні`;
    });
    this.cancelButtonClass = computed(() => {
      const data = this.data();

      return `btn-outline-${data?.cancelButtonPalette || 'secondary'}`;
    });
    this.confirmButtonLabel = computed(() => {
      const data = this.data();

      return data?.confirmButtonLabel || $localize`Так`;
    });
    this.confirmButtonClass = computed(() => {
      const data = this.data();

      return `btn-${data?.confirmButtonPalette || 'primary'}`;
    });
  }
}
